import { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const LogoPanel = ({ cid, logo, onLogo }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(`/customers/${cid}/logo`, fd);
      onLogo(data.logo);
      toast.success("Logoen er lastet opp");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };

  const remove = async () => {
    try {
      if (!window.confirm("Fjerne logoen?")) return;
      await api.delete(`/customers/${cid}/logo`);
      onLogo(null);
      toast.success("Logoen er fjernet");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4">
      <div className="w-40 h-20 rounded-md border border-dashed border-slate-300 bg-white flex items-center justify-center overflow-hidden" data-testid="logo-preview">
        {logo ? <img src={logo} alt="Logo" className="max-w-full max-h-full object-contain p-2" /> : <span className="text-xs text-slate-400">Ingen logo</span>}
      </div>
      <div className="space-y-2">
        <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden"
          onChange={(e) => upload(e.target.files?.[0])} data-testid="logo-file-input" />
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => input.current?.click()} disabled={busy} data-testid="logo-upload-button">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ImagePlus className="w-4 h-4 mr-2" />}Last opp logo
          </Button>
          {logo && (
            <Button variant="ghost" onClick={remove} className="text-slate-500 hover:text-red-600" data-testid="logo-remove-button">
              <Trash2 className="w-4 h-4" />
            </Button>
          )}
        </div>
        <p className="text-xs text-slate-500">PNG, JPG eller WEBP, maks 1,5 MB. Vises kun i admin og i PDF-rapporter.</p>
      </div>
    </div>
  );
};
